var _circle, _path, _path2, _circle2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisabledAccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 26.5,
    stroke: "#e6e6e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5889 28.6953H32.0537C32.8112 28.6953 33.5037 29.1233 33.8425 29.8009L38.1762 38.4682",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8523 25.3066C17.418 26.7148 15.7803 29.3467 15.7803 32.3612C15.7803 36.859 19.4265 40.5053 23.9244 40.5053C27.1479 40.5053 29.9341 38.6324 31.254 35.9154",
    stroke: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.9236,
    cy: 15.2576,
    r: 2.75763,
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8832 25.6388L27.767 25.6388C27.2937 25.6388 26.8912 25.2936 26.8191 24.8259L26.3456 21.7537C26.1366 20.3977 24.8311 19.496 23.4889 19.7805V19.7805C22.249 20.0434 21.4301 21.2289 21.6232 22.4816L22.8936 30.7242C23.1618 32.4638 24.8077 33.6428 26.541 33.337L29.0071 32.9018L29.4084 32.8202C30.7377 32.5497 32.0832 33.205 32.6898 34.4183L35.7336 40.5058",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledAccess);
export default __webpack_public_path__ + "static/media/disabled_access.634632bd08c87f2d7116f1b3ddcd0230.svg";
export { ForwardRef as ReactComponent };